export enum PsychomotorActivity {
    WNL = 'WNL',
    SLURRED = 'Slurred',
    CONFABULATION = 'Confabulation',
    INCOHERENT = 'Incoherent',
    AGITATED = 'Agitated',
    SLOWED = 'Slowed'
}